
export const STATUS = {
  APPROVED: 'APPROVED',
  CANCELLED: 'CANCELLED',
  CHANGE_REQUESTED: 'CHANGE REQUESTED',
  DRAFT: 'DRAFT',
  SUBMITTED: 'SUBMITTED'
} as const;

export type StatusKey = typeof STATUS[keyof typeof STATUS];

export const STATUS_MAP: Record<StatusKey, string> = {
  [STATUS.APPROVED]: 'Approved',
  [STATUS.CANCELLED]: 'Cancelled',
  [STATUS.CHANGE_REQUESTED]: 'Change Requested',
  [STATUS.DRAFT]: 'Draft',
  [STATUS.SUBMITTED]: 'Submitted',
};

export const STATUS_COLORS: Record<any | 'default', { color: string; backgroundColor: string }> = {
  [STATUS.DRAFT]: { color: "#919191", backgroundColor: "#919191" },
  [STATUS.SUBMITTED]: { color: "#FFFF00", backgroundColor: "#FFFF00" },
  [STATUS.CHANGE_REQUESTED]: { color: "#F49632", backgroundColor: "#F49632" },
  [STATUS.APPROVED]: { color: "#78A22F", backgroundColor: "#78A22F" },
  [STATUS.CANCELLED]: { color: "#C43131", backgroundColor: "#C43131" },
  default: { color: "#353535", backgroundColor: "#353535" }
};

/**
 * get status badge color
 * @param status 
 * @returns 
 */
export const getStatusStyles = (status: string) => {
  return STATUS_COLORS[status] || STATUS_COLORS.default;
};

/**
 * Get display label for status value.
 * Falls back to raw status if not found in map.
 */
export function getStatusLabel(status?: string): string {
  if (!status) return '';

  const key = status.toUpperCase() as StatusKey;

  return STATUS_MAP[key] || status;
}
